/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkResolveTaskChangeRequestDto } from '../models/work-resolve-task-change-request-dto';
import { WorkTaskChangeRequest } from '../models/work-task-change-request';

@Injectable({ providedIn: 'root' })
export class WorkTaskChangeRequestsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `taskChangeRequestsV2ControllerFindAllPaginated()` */
  static readonly TaskChangeRequestsV2ControllerFindAllPaginatedPath = '/v2/task-change-requests';

  /**
   * Required permissions: tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangeRequestsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangeRequestsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'status:ASC' | 'status:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTaskChangeRequest>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskChangeRequestsV2Service.TaskChangeRequestsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.status', params['filter.status'], {});
      rb.query('filter.projectId', params['filter.projectId'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkTaskChangeRequest>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'status'?: (string | Array<string>);
        'projectId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangeRequestsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangeRequestsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by status query param.
     *           <p>
     *              <b>Format: </b> filter.status={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.status=$not:$like:John Doe&filter.status=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.status'?: Array<string>;

    /**
     * Filter by projectId query param.
     *           <p>
     *              <b>Format: </b> filter.projectId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.projectId=$not:$like:John Doe&filter.projectId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.projectId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> created:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>created</li>
     * <li>status</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'created:ASC' | 'created:DESC' | 'status:ASC' | 'status:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkTaskChangeRequest>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
};
};
}> {
    return this.taskChangeRequestsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkTaskChangeRequest>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkTaskChangeRequest>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'status'?: (string | Array<string>);
'projectId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `taskChangeRequestsV2ControllerFindByProjectId()` */
  static readonly TaskChangeRequestsV2ControllerFindByProjectIdPath = '/v2/task-change-requests/project/{projectId}';

  /**
   * Required permissions: tasks:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangeRequestsV2ControllerFindByProjectId()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangeRequestsV2ControllerFindByProjectId$Response(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTaskChangeRequest>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskChangeRequestsV2Service.TaskChangeRequestsV2ControllerFindByProjectIdPath, 'get');
    if (params) {
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTaskChangeRequest>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangeRequestsV2ControllerFindByProjectId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  taskChangeRequestsV2ControllerFindByProjectId(
    params: {

    /**
     * Project ID
     */
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTaskChangeRequest>> {
    return this.taskChangeRequestsV2ControllerFindByProjectId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTaskChangeRequest>>): Array<WorkTaskChangeRequest> => r.body)
    );
  }

  /** Path part for operation `taskChangeRequestsV2ControllerAccept()` */
  static readonly TaskChangeRequestsV2ControllerAcceptPath = '/v2/task-change-requests/{id}/accept';

  /**
   * Required permissions: tasks:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangeRequestsV2ControllerAccept()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskChangeRequestsV2ControllerAccept$Response(
    params: {

    /**
     * Task Change Request ID
     */
      id: number;
      body: WorkResolveTaskChangeRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskChangeRequest>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskChangeRequestsV2Service.TaskChangeRequestsV2ControllerAcceptPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskChangeRequest>;
      })
    );
  }

  /**
   * Required permissions: tasks:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangeRequestsV2ControllerAccept$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskChangeRequestsV2ControllerAccept(
    params: {

    /**
     * Task Change Request ID
     */
      id: number;
      body: WorkResolveTaskChangeRequestDto
    },
    context?: HttpContext
  ): Observable<WorkTaskChangeRequest> {
    return this.taskChangeRequestsV2ControllerAccept$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskChangeRequest>): WorkTaskChangeRequest => r.body)
    );
  }

  /** Path part for operation `taskChangeRequestsV2ControllerReject()` */
  static readonly TaskChangeRequestsV2ControllerRejectPath = '/v2/task-change-requests/{id}/reject';

  /**
   * Required permissions: tasks:update
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `taskChangeRequestsV2ControllerReject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskChangeRequestsV2ControllerReject$Response(
    params: {

    /**
     * Task Change Request ID
     */
      id: number;
      body: WorkResolveTaskChangeRequestDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTaskChangeRequest>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTaskChangeRequestsV2Service.TaskChangeRequestsV2ControllerRejectPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTaskChangeRequest>;
      })
    );
  }

  /**
   * Required permissions: tasks:update
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `taskChangeRequestsV2ControllerReject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  taskChangeRequestsV2ControllerReject(
    params: {

    /**
     * Task Change Request ID
     */
      id: number;
      body: WorkResolveTaskChangeRequestDto
    },
    context?: HttpContext
  ): Observable<WorkTaskChangeRequest> {
    return this.taskChangeRequestsV2ControllerReject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTaskChangeRequest>): WorkTaskChangeRequest => r.body)
    );
  }

}
